// react
import axios from "axios";
// components
import SharedHandler from "src/components/UI/Shared/handler";
import user from "src/components/UI/Shared/user";

const generatesignature = (endpointUrl: string) => {
  const timestamp = new Date().toISOString();
  const signature = SharedHandler.signRequest(
    "/" + endpointUrl,
    "POST",
    timestamp
  );

  return {
    signature: signature,
    timestamp: timestamp,
  };
};
export const handleRequest = async (
  apiURL: string,
  endpointUrl: string,
  formData: FormData,
  basename: string,
  resType: any,
  contentType: any,
  fileType: any,
  optionalParam: string,
  json?: string
) => {
  const ip = user.parseUserIp();
  formData.append("ip", ip);
  const email = user.parseUserEmail();
  formData.append("user_email", email);
  const { signature, timestamp } = generatesignature(endpointUrl);
  let fileName =
    fileType === "application/json"
      ? basename + ".geojson"
      : fileType === "application/vnd.google-earth.kmz"
      ? basename + ".kmz"
      : basename;
  fileName = json === "json" ? basename + ".json" : fileName;
  let returned = { flag: "", message: [""] };
  if (optionalParam === "0") {
    endpointUrl = endpointUrl + `?reset=0`;
  }
  await axios
    .post(apiURL + endpointUrl, formData, {
      responseType: resType,
      headers: {
        "Content-Type": contentType,
        "X-Signature": signature,
        "X-Timestamp": timestamp,
      },
    })
    .then((response) => {
      const response_data = SharedHandler.decodeResponse(response);
      console.log(response_data);
      if (response_data.verification_status) {
        if (response_data.captcha) {
          returned = {
            flag: "TRACKING",
            message: [response_data.verification_status, response_data.captcha],
          };
        } else {
          returned = {
            flag: "TRACKING",
            message: [response_data.verification_status],
          };
        }
      } else if (response.data.error) {
        returned = { flag: "ERROR", message: [response.data.error] };
      } else if (response_data.error) {
        returned = { flag: "ERROR", message: [response_data.error] };
      } else if (fileType === "application/json" && response.data) {
        const fileBlob = SharedHandler.createFileBlobHandler(
          JSON.stringify(response.data),
          "application/json"
        );
        SharedHandler.saveFile(fileBlob, fileName);
        returned = { flag: "SUCCESS", message: [""] };
      } else {
        console.log(fileName, fileType);
        SharedHandler.fileDownloadHandler(response, fileName, fileType);
        returned = { flag: "SUCCESS", message: [""] };
      }
    })
    .catch((error) => {
      returned = { flag: "ERROR", message: ["Error happened."] };
    });

  return returned;
};
export const saveFileToLocalStorage = (basename: string, file_data: any) => {
  const name = "GISimplify_" + basename;
  const current_user = user.getCurrentLoggedIn();
  const data = localStorage.getItem(current_user);
  if (data) {
    const user_data = JSON.parse(data);
    const new_data = user_data;
    try {
      new_data.files = user_data.files;
      new_data.files[name] = {
        data: file_data,
        ref: name,
      };
    } catch {
      new_data["files"] = {};
      const files = new_data["files"];
      files[name] = {
        data: file_data,
        ref: name,
      };
    }
    localStorage.setItem(current_user, JSON.stringify(new_data));
  }
};
